import React, { FC } from 'react';

import { AttributeDataType } from '../../../src/models/IAttributes';
import type { IAttributes } from '../../../src/models/IAttributes';

import styles from './styles.module.scss';
import { IAssemblyType, assemblyDictionary } from 'entities/products';

const renderArrayValue = (value: any) => {
  if (!Array.isArray(value)) return null;

  return value.map((item) => (
    <div key={item} className={styles.attributeValueMultipleItem}>
      {item}
    </div>
  ));
};

const renderBooleanValue = (value: any) => {
  return value ? 'Да' : 'Нет';
};

const renderColorValue = (value: any) => {
  if (!Array.isArray(value)) return null;

  return value.map((item) => (
    <div key={item.value} className={styles.attributeValueMultipleItem}>
      {item.value}
    </div>
  ));
};

const renderDateValue = (value: any) => {
  try {
    const formatDate = new Date(value).toLocaleDateString();
    return formatDate;
  } catch (err) {
    console.error(err);
  }

  return null;
};

const attributeValueRenderersMap: Record<AttributeDataType, (value: any) => any> = {
  STRING: (value) => value,
  INTEGER: (value) => value,
  DECIMAL: (value) => value,
  COLOR: renderColorValue,
  DATE: renderDateValue,
  BOOLEAN: renderBooleanValue,
  MANY_FROM_MANY: renderArrayValue,
  ONE_FROM_MANY: (value) => value,
};

interface AttributeItemValue {
  type?: string;
  value?: any;
}

const AttributeItemValue: FC<AttributeItemValue> = (props) => {
  const { type, value } = props;

  const renderer = attributeValueRenderersMap[type];

  if (value === undefined || !renderer) return <>-</>;

  const component = renderer(value);

  return <div className={styles.attributeValue}>{component || <>-</>}</div>;
};

interface AttributeItem {
  data: IAttributes;
}

const AttributeItem: FC<AttributeItem> = ({ data }) => {
  return (
    <div className={styles.attributeItem}>
      <div className={styles.attributeTitle}>{data.attribute.name}</div>
      <AttributeItemValue type={data.attribute.data_type} value={data.value} />
    </div>
  );
};

interface IProductAttributes {
  attributes: IAttributes[];
  weight?: number | null;
  assembly: IAssemblyType;
}

const ProductAttributes: FC<IProductAttributes> = ({ attributes, weight, assembly }) => {
  return (
    <div className={styles.container}>
      <div className={styles.attributesBlock}>
        {attributes &&
          attributes.map((item) => {
            return (item.attribute.data_type === 'BOOLEAN' && item.value !== undefined) || item.value ? (
              <AttributeItem key={item.attribute.id} data={item} />
            ) : null;
          })}
      </div>
      {weight && (
        <div className={styles.attributeItem}>
          <div className={styles.attributeTitle}>Вес товара (кг):</div>
          <div className={styles.attributeValue}>{weight / 1000}</div>
        </div>
      )}
      <div className={styles.attributeItem}>
        <div className={styles.attributeTitle}>Сборка:</div>
        <div className={styles.attributeValue}>{assemblyDictionary[assembly]}</div>
      </div>
    </div>
  );
};

export { ProductAttributes };
